var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5188,
    cy: 12,
    rx: 11.7654,
    ry: 12,
    fill: "#DFE1E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0273 9H16.2876V7.5C16.2876 5.43 14.6306 3.75 12.589 3.75C10.5473 3.75 8.89032 5.43 8.89032 7.5V9H8.15059C7.3369 9 6.67114 9.675 6.67114 10.5V18C6.67114 18.825 7.3369 19.5 8.15059 19.5H17.0273C17.841 19.5 18.5068 18.825 18.5068 18V10.5C18.5068 9.675 17.841 9 17.0273 9ZM12.589 15.75C11.7753 15.75 11.1095 15.075 11.1095 14.25C11.1095 13.425 11.7753 12.75 12.589 12.75C13.4026 12.75 14.0684 13.425 14.0684 14.25C14.0684 15.075 13.4026 15.75 12.589 15.75ZM14.8821 9H10.2958V7.5C10.2958 6.2175 11.324 5.175 12.589 5.175C13.8539 5.175 14.8821 6.2175 14.8821 7.5V9Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure_icon.fa4319426cdc0bcc2465e12d95598a1b.svg";
export { ForwardRef as ReactComponent };